import {Trait} from '../../../util';

export const ExcludedReports = {
    BOTH_CANCERS: 'both',
    BREAST_CANCER: Trait.BC.code,
    NEITHER_CANCERS: 'neither',
    PROSTATE_CANCER: Trait.PC.code,
};
